angular
  .module("myApp")
  .controller(
    "KonsolidetaisVertejumsLzpEditController",
    function (
      $scope,
      $rootScope,
      $timeout,
      uuiData,
      Dialog,
      Notification,
      Codifiers,
      LzpKonsolidetaisVertejumsSubmit,
      LzpKonsolidetaisVertejumsSet,
    ) {
      $scope.cons_prerequisites = false;

      this.init = (eksperts_id, ekspertize_id) => {
        // mani labojamie kritēriji
        this.eksperts_id = eksperts_id;
        this.ekspertize_id = ekspertize_id;
        this.pd_versija_id = $scope.dto.id;

        this.load_kriteriji();
      };

      this.set_statuss = (statuss) => {
        $scope.statuss = statuss;
        $scope.vertejums_submittable = statuss === "VAR-IESNIEGT" || statuss === "VAR-NORAIDIT";
        $scope.vertejums_revertable = statuss === "IESNIEGTS" || statuss === "NORAIDITS";
        $scope.vertejums_finished = statuss === "IESNIEGTS" || statuss === "NORAIDITS";
      };

      this.load_kriteriji = () => {
        uuiData.list(
          "lzp_konsolidetais_vertejums",
          {
            ekspertize_id: this.ekspertize_id,
            pd_versija_id: this.pd_versija_id,
          },
          update_kriteriji,
        );
      };

      this.load_status = () => {
        uuiData.list(
          "lzp_konsolidetais_vertejums",
          {
            ekspertize_id: this.ekspertize_id,
            pd_versija_id: this.pd_versija_id,
          },
          (lzp_vertejumi) => {
            this.set_statuss(lzp_vertejumi[0].konsolid_statuss);
          },
        );
      };

      this.get_others = (crit) => {
        // atdod saraksta formā to, kā balsojuši pārējie lietotāji
        if (!crit.others) {
          const out = [];
          $scope.vertejums.eksperti.forEach((e) => {
            e.eksperta_viedoklis.forEach((v) => {
              if (v.kriterija_kods === crit.kriterija_kods) {
                out.push({
                  vards: e.vards,
                  uzvards: e.uzvards,
                  atbilstiba: v.atbilstiba,
                  komentars: v.komentars,
                });
              }
            });
          });
          crit.others = out;
        }
        return crit.others;
      };

      const update_kriteriji = (lzp_vertejumi) => {
        const lzp_vertejums = lzp_vertejumi[0]; // hack dēļ tā, ka lzp_vertejums ir lists

        const eksp_veids = lzp_vertejums.veids;

        this.set_statuss(lzp_vertejums.konsolid_statuss);
        $scope.vertejums = lzp_vertejums;

        $scope.cons_prerequisites = lzp_vertejums.eksperti.length >= 2;

        Codifiers.kriteriji().$promise.then((ks) => {
          const out = [];

          ks.forEach((k) => {
            if (k.karta_min && $scope.dto.pieteikumu_karta_id < k.karta_min) return;
            if (k.karta_max && $scope.dto.pieteikumu_karta_id > k.karta_max) return;
            if (k.datums_min && $scope.dto.iesniegsanas_datums < k.datums_min) return;
            if (k.datums_max && $scope.dto.iesniegsanas_datums > k.datums_max) return;

            if (eksp_veids === "LZP.NP" && !k.kriterija_kods.startsWith("lzp.np")) return;
            if (eksp_veids === "LZP.PP" && !k.kriterija_kods.startsWith("lzp.pp")) return;

            if (k.ir_saimniecisks === false && $scope.dto.ar_saimniecisku_darbibu_saistits) return;
            if (k.ir_nesaimniecisks === false && !$scope.dto.ar_saimniecisku_darbibu_saistits) return;

            const krit = { ...k };

            lzp_vertejums.kriteriji.forEach((mk) => {
              if (mk.kriterija_kods === k.kriterija_kods) {
                krit.atbilstiba = mk.atbilstiba;
                krit.komentars = mk.komentars;
              }
            });

            out.push(krit);
          });
          console.log({ cons_kriteriji: out });
          $scope.kriteriji = out;
          this.updateScore();
        });
      };

      this.set = (crit, val) => {
        const commentable =
          (crit.veids === "NE-JA" || crit.veids === "NEATB-ATB") && crit.opcijas_json.silent !== true;

        if (!commentable && crit.komentars) {
          crit.tmp_komentars = crit.komentars;
          crit.komentars = undefined;
        }
        if (commentable && crit.tmp_komentars) {
          crit.komentars = crit.tmp_komentars;
          crit.tmp_komentars = undefined;
        }
        if (commentable) {
          return Dialog.dialog(
            "pages/dialogs/comment.form.html",
            {
              komentars: crit.komentars,
              _allow_empty: val === "JA",
            },
            (p, action) => {
              if (action === "save") {
                crit.atbilstiba = val;
                crit.komentars = p.komentars;
                this.save();
              }
            },
          );
        }
        if (crit.atbilstiba === val) {
          // jau aizklikšķināts, unclickojam visus
          $scope.kriteriji.forEach((k) => {
            if (k.veids === "ONE-OF" && k.opcijas_json.tag === crit.opcijas_json.tag) {
              k.atbilstiba = undefined;
            }
          });
        } else {
          $scope.kriteriji.forEach((k) => {
            if (k.veids === "ONE-OF" && k.opcijas_json.tag === crit.opcijas_json.tag) {
              k.atbilstiba = "NE";
            }
          });
          crit.atbilstiba = val;
          this.save();
        }
      };

      this.submit = () => {
        const r = new LzpKonsolidetaisVertejumsSubmit({
          id: this.ekspertize_id,
        });
        r.$create(() => {
          Notification.success("Konsolidētais vērtējums ir iesniegts, paldies!");
          this.load_kriteriji();
          $scope.reload();
        }, $scope.failing);
      };

      this.updateScore = () => {
        let score = 0;
        $scope.kriteriji.forEach((k) => {
          if (k.atbilstiba === "JA" || k.atbilstiba === "AR_PIEZIMEM") {
            if (k.punkti) {
              score += k.punkti;
            }
          }
        });
        $scope.score = score;
        console.log({ score });
        return score;
      };

      let expsave;

      this.save = () => {
        if (expsave) $timeout.cancel(expsave);

        expsave = $timeout(() => {
          expsave = undefined;

          const d = {
            id: this.ekspertize_id,
            punkti: this.updateScore(),
            kriteriji: [],
          };
          _.each($scope.kriteriji, (k) => {
            if (k.atbilstiba) {
              d.kriteriji.push({
                kriterija_kods: k.kriterija_kods,
                atbilstiba: k.atbilstiba,
                komentars: k.komentars,
              });
            }
          });
          if (d.kriteriji.length > 0) {
            const v = new LzpKonsolidetaisVertejumsSet(d);
            v.$save(this.load_status, $scope.failing);
          }
        }, 1000);
      };
    },
  );
